export default "__VITE_ASSET__Cy$gRaiG__"